/**
 * Pixel-art icons of the HUD's buttons, in place of their words (author's choice): a fist for ACTION, a die for an
 * invader at random, a die with an arrow for « Poser au hasard », a cross and a skip for Cancel and End turn on small
 * screens. The words stay in the tooltips.
 */
import { gridIcon } from './weapon-icons';

const GRIDS = {
  /** ACTION: play the highlighted unit. */
  fist: [
    '....kkkkkkkk...',
    '...kwwkwwkwwk..',
    '..kkwwkwwkwwkk.',
    '.kwkwwkwwkwwkwk',
    '.kwkwwkwwkwwkwk',
    '.kwkggkggkggkgk',
    'kwwwwwwwkkkkkgk',
    'kwwwwwwwwwkwwgk',
    'kgwwwwwwwwkwggk',
    '.kggggggggkggk.',
    '.kwkkkkkkkkgk..',
    '..kwwwwwwwwgk..',
    '..kgwwwwwwggk..',
    '...kkkkkkkkk...',
  ],
  /** An invader at random. */
  die: [
    '.kkkkkkkkkkkk.',
    'kwwwwwwwwwwwgk',
    'kwkkwwwwwwkkgk',
    'kwkkwwwwwwkkgk',
    'kwwwwwwwwwwwgk',
    'kwwwwwwwwwwwgk',
    'kwwwwwkkwwwwgk',
    'kwwwwwkkwwwwgk',
    'kwwwwwwwwwwwgk',
    'kwwwwwwwwwwwgk',
    'kwkkwwwwwwkkgk',
    'kwkkwwwwwwkkgk',
    'kggggggggggggk',
    '.kkkkkkkkkkkk.',
  ],
  /** Put the invader on a valid spot at random: a die, and an arrow going down. */
  dieDrop: [
    '.kkkkkkkkkk.....',
    'kwwwwwwwwwgk....',
    'kwkkwwwwwwgk....',
    'kwkkwwwwwwgk....',
    'kwwwwkkwwwgk....',
    'kwwwwkkwwwgk....',
    'kwwwwwwkkwgk....',
    'kwwwwwwkkwgk....',
    'kwwwwwwwwkkkkk..',
    'kggggggggkvvVk..',
    '.kkkkkkkkkvvVkkk',
    '.......kvvvvvvVk',
    '........kvvvvVk.',
    '.........kvvVk..',
    '..........kVk...',
    '...........k....',
  ],
  /** Cancel, back to the previous step: a red cross. */
  cancel: [
    '.kk......kk.',
    'krrk....krrk',
    'krork..krork',
    '.krorkkrork.',
    '..krorrork..',
    '...kroork...',
    '...kroork...',
    '..krorrork..',
    '.krorkkrork.',
    'krork..krork',
    'krrk....krrk',
    '.kk......kk.',
  ],
  /** End the turn: skip to the next player (two arrows and a bar). */
  endTurn: [
    'kk....kk...kk',
    'kyk...kyk..ky',
    'kyyk..kyyk.ky',
    'kyyyk.kyyykky',
    'kyyyyykyyyyky',
    'kyyyyyykyyyky',
    'kyyyyyykyyyky',
    'kyyyyykyyyyky',
    'kyyyk.kyyykky',
    'kyyk..kyyk.ky',
    'kyk...kyk..ky',
    'kk....kk...kk',
  ],
  /** A ghost turn's chest (the treasure chest of the GDD, page 20). */
  chest: [
    '..kkkkkkkkkk..',
    '.knnnnnnnnnnk.',
    'knNnnnnnnnnNnk',
    'knNnnnnnnnnNnk',
    'kyyyyykkyyyyyk',
    'kkkkkkyykkkkkk',
    'knNnnnkknnnNnk',
    'knNnnnnnnnnNnk',
    'knNnnnnnnnnNnk',
    'kyyyyyyyyyyyyk',
    '.kkkkkkkkkkkk.',
  ],
} as const;

export type UiIcon = keyof typeof GRIDS;

const cache = new Map<UiIcon, string>();

/** The icon as an image URL (16 × 16). */
export function uiIcon(name: UiIcon): string {
  let url = cache.get(name);
  if (url === undefined) {
    url = gridIcon(GRIDS[name]);
    cache.set(name, url);
  }
  return url;
}

/** An <img> of the icon for innerHTML, sized by the class `pxicon` (and `extra`). */
export function uiIconHtml(name: UiIcon, extra = ''): string {
  return `<img class="pxicon${extra ? ` ${extra}` : ''}" src="${uiIcon(name)}" alt="" />`;
}
